function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Col, Row, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import ReportNotesForm from './ProjectNotesForm';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
export default function ProjectComments(_ref) {
  let {
    report,
    setReport,
    reportNotesHandlers
  } = _ref;
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const {
    notes,
    setNotes,
    createNote,
    loading
  } = reportNotesHandlers;
  const handleCreateNote = async formData => {
    try {
      const response = await createNote(formData);
      const updatedNotes = [response, ...notes];
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport(_objectSpread({}, report));
      setShowCommentPopup(true);
      setHasUnsavedChanges(false);
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const popover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-basic"
  }, /*#__PURE__*/React.createElement(Popover.Body, null, t('comment_saved_to_comments_tab'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
    to: "".concat(location.pathname, "?key=notes")
  }, t('link_to_comment'))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-primary",
    onClick: () => setShowCommentPopup(false)
  }, t('close')))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "right",
    show: showCommentPopup,
    rootClose: true,
    overlay: popover
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReportNotesForm, {
    loading: loading,
    onSubmit: handleCreateNote,
    noteType: "summary",
    isImmutableUnderReview: true,
    setHasUnsavedChanges: setHasUnsavedChanges
  }))))));
}